export default "__VITE_ASSET__DhK1Pg77__"